<div class="row">
    <div
        class="multi-picking-task-identifier"
        *ngIf="orderItem.multipickingTaskIdentifierChar"
        [ngStyle]="{ 'background-color': orderItem.multipickingTaskIdentifierColor }"
    >
        {{ orderItem.multipickingTaskIdentifierChar }}
    </div>

    <div class="orderitem-status-badge">
        <div *ngIf="!orderItem.state" class="bg-info">
            <span class="fa fa-search fa-lg"></span>
            {{ 'collecting.items-to-pick' | translate }}
        </div>
        <div *ngIf="orderItem.state == orderItemState.Collected" class="bg-success">
            <span class="fa fa-cart-arrow-down fa-lg"></span>
            {{ 'collecting.collected-items' | translate }}
        </div>
        <div *ngIf="orderItem.state == orderItemState.Replaced" class="bg-warning">
            <span class="fa fa-refresh fa-lg"></span>
            {{ 'collecting.replaced-items' | translate }}
        </div>
        <div *ngIf="orderItem.state == orderItemState.NotFound" class="bg-danger">
            <span class="fa fa-exclamation-triangle fa-lg"></span
            >{{ 'collecting.missing-items' | translate }}
        </div>
    </div>

    <div (click)="goToPreviousOrderItem()" class="arrow arrow-left">
        <i class="fa fa-arrow-left"></i>
    </div>
    <div (click)="goToNextOrderItem()" class="arrow arrow-right">
        <i class="fa fa-arrow-right"></i>
    </div>

    <div class="map-position">
        <app-product-location-map
            [orderItem]="orderItem"
            [openedFromOrderItemDetails]="true"
        >
        </app-product-location-map>
    </div>
    <div class="mb-2 col-12">
        <div *ngIf="orderItem.shelfDisplayNameKey" class="mb-1">
            <div class="mr-5">
                <strong>
                    <i class="fa fa-flag"></i>&nbsp;{{
                        'collecting.shelf-text' | translate
                    }}:
                </strong>
                {{ orderItem.shelfDisplayNameKey | translate }}

                <strong
                    class="text-success"
                    *ngIf="canEditProductMap && !shelfDisplayNameKeyEditInProgress"
                    (click)="editShelfDisplayNameKey()"
                >
                    &nbsp;&nbsp;&nbsp; <i class="fa fa-edit fa-icon-map-edit"></i>
                </strong>

                <strong
                    class="text-danger"
                    *ngIf="canEditProductMap && shelfDisplayNameKeyEditInProgress"
                    (click)="closeShelfDisplayNameKey()"
                >
                    &nbsp;&nbsp;&nbsp; <i class="fa fa-close fa-icon-map-edit"></i>
                </strong>
            </div>
            <div
                *ngIf="canEditProductMap && shelfDisplayNameKeyEditInProgress"
                class="mb-5"
            >
                <div>
                    <h4>{{ 'collecting.select-new-map' | translate }}</h4>
                    <ng-select
                        [items]="maps"
                        [(ngModel)]="selectedMap"
                        (change)="setNewMap()"
                        class="mb-1"
                    >
                    </ng-select>
                    <button
                        class="btn btn-success w-100"
                        (click)="saveShelfDisplayNameKey()"
                    >
                        {{ 'common.save' | translate }}
                        <i class="fa fa-save fa-icon-map-edit"></i>
                    </button>
                </div>
                <br />
                <img src="{{ selectedMapImageURL }}" class="img" />
            </div>
        </div>

        <div *ngIf="orderItem.shelfPositionDisplayNameKey" class="mb-1">
            <div class="mr-5">
                <strong>
                    <i class="fa fa-arrow-up"></i>&nbsp;{{
                        'collecting.shelf-position-text' | translate
                    }}:
                </strong>
                {{ orderItem.shelfPositionDisplayNameKey | translate }}

                <strong
                    class="text-success edit-position"
                    *ngIf="
                        canEditProductMap && !shelfPositionDisplayNameKeyEditInProgress
                    "
                    (click)="editShelfPositionDisplayNameKey()"
                >
                    &nbsp;&nbsp;&nbsp; <i class="fa fa-edit"></i>
                </strong>
                <strong
                    class="text-danger"
                    *ngIf="canEditProductMap && shelfPositionDisplayNameKeyEditInProgress"
                    (click)="closeShelfPositionDisplayNameKey()"
                >
                    &nbsp;&nbsp;&nbsp; <i class="fa fa-close fa-icon-map-edit"></i>
                </strong>
            </div>
            <div
                *ngIf="canEditProductMap && shelfPositionDisplayNameKeyEditInProgress"
                class="mb-5"
            >
                <div>
                    <h4>{{ 'collecting.select-new-shelf' | translate }}</h4>
                    <ng-select
                        [items]="shelves"
                        [(ngModel)]="selectedShelf"
                        (change)="setNewShelfPosition()"
                        class="mb-1"
                    >
                    </ng-select>
                    <button
                        class="btn btn-success w-100"
                        (click)="saveShelfPositionDisplayNameKey()"
                    >
                        {{ 'common.save' | translate }}
                        <i class="fa fa-save fa-icon-map-edit"></i>
                    </button>
                </div>
                <hr />
            </div>
        </div>

        <p class="mb-1" *ngIf="orderItem.categoryNameToDisplayTranslationCode">
            <strong>
                <i class="fa fa-tag"></i>&nbsp;{{
                    orderItem.categoryNameToDisplayTranslationCode | translate
                }}</strong
            >
        </p>

        <p *ngIf="orderItem.currentPrice" class="mb-1">
            <strong>
                <i class="fa fa-money"></i>&nbsp;{{
                    'collecting.current-price-text' | translate
                }}:
            </strong>
            {{ orderItem.currentPrice | priceround }}
            {{ 'common.currency' | translate }}
        </p>
        <p *ngIf="orderItem.isOffer" class="mb-1">
            <strong>
                <i class="fa fa-percent"></i>&nbsp;{{
                    'collecting.offer-text' | translate
                }}:
            </strong>
            {{ orderItem.offerValidTo | date : 'yyyy-MM-dd' }}
        </p>
    </div>
    <div
        *ngIf="
            orderItem.state === orderItemState.Collected &&
            orderItem.orderReplacementItem !== null
        "
        class="col-12"
    >
        <p>{{ 'collecting.replacement-order-item' | translate }}</p>
    </div>
    <div class="col-12">
        <app-order-item-details
            [orderItem]="orderItem"
            [isMainPageCollecting]="false"
        ></app-order-item-details>
    </div>
</div>
<div
    *ngIf="
        orderItem.state === orderItemState.Collected &&
        orderItem.orderReplacementItem !== null &&
        orderItem.orderReplacementItem.quantityRequestedByUser === 0
    "
    class="col-12 alert alert-danger"
>
    <p class="m-0">
        {{ 'collecting.not-requested-by-customer' | translate }}
    </p>
</div>
<div
    *ngIf="
        orderItem.state === orderItemState.Collected &&
        orderItem.orderReplacementItem !== null
    "
    class="row mt-3"
>
    <div class="col-12">
        <p>{{ 'collecting.original-order-item' | translate }}</p>
    </div>
    <div class="col-12">
        <table>
            <tr>
                <td>{{ orderItem.originalItemName }}</td>
            </tr>
            <td class="font-weight-bold">
                {{ 'collecting.quantity' | translate }}:
                {{ orderItem.orderedQuantity }}
                {{ 'collecting.' + orderItem.unit | translate }}
            </td>
        </table>
    </div>
</div>
<br /><br /><br />
<div class="card-footer">
    <div class="btn-toolbar justify-content-between mr-3">
        <div
            class="btn-group btn-group-sm mr-5"
            app-items-to-collect-buttons
            *ngIf="orderItem.state === null"
            [canCollectManually]="!states.hasMarkupPayment"
            [orderItem]="orderItem"
            [orderRemovedItemReasons]="orderRemovedItemReasons"
        ></div>
        <div
            class="btn-group btn-group-sm mr-5"
            app-collected-items-buttons
            *ngIf="orderItem.state === orderItemState.Collected"
            [orderItem]="orderItem"
        ></div>
        <div
            class="btn-group btn-group-sm mr-5"
            app-replaced-items-buttons
            *ngIf="orderItem.state === orderItemState.Replaced"
            [orderItem]="orderItem"
            [canEditManually]="!states.hasMarkupPayment"
            [hasBarcodeReader]="states.isBarcodeReadingEnabled"
        ></div>
        <div
            class="btn-group btn-group-sm mr-5"
            app-items-not-found-buttons
            *ngIf="orderItem.state == orderItemState.NotFound"
            [orderItem]="orderItem"
        ></div>
    </div>
    <div *ngIf="states.isBarcodeReadingEnabled; else noBarcode" class="identifier-btn">
        <app-btn-action
            class="mr-1"
            [btnClass]="
                'btn btn-primary btn-circle btn-lg btn-lateral add-new-product-button'
            "
            [iconClass]="'fa fa-search'"
            (click)="showProductIdentifyModal()"
            [disabled]="states.isCollectingForbidden"
        >
        </app-btn-action>
    </div>
    <ng-template #noBarcode>
        <div class="identifier-btn">
            <app-btn-action
                [btnClass]="
                    'btn btn-warning btn-circle btn-lg btn-lateral add-new-product-button'
                "
                [iconClass]="'fa fa-plus'"
                (click)="showCreateItemModal()"
                [disabled]="states.isCollectingForbidden"
            >
            </app-btn-action>
        </div>
    </ng-template>
</div>
